import { combineReducers } from 'redux';
import { intlReducer } from 'react-intl-redux';

import { reducer as authReducer } from '../sagas/aws-cognito-redux-saga';
import entries from './entries';
import error from './error';
import hairDiagnosis from './hairDiagnosis';
import locale from './locale';
import newsAndEvents from './newsAndEvents';
import pages from './pages';
import {
  productRangeSkinBodyCare,
  productRangeHairCare,
  productRangeHairColor,
  productRangeMakeUp,
  productRangeMens,
  productRangePerm,
  productRangeStyling,
} from './productRange';
import screenSize from './screenSize';
import searchables from './searchables';
import seminars from './seminars';
import seminarSpecifics from './seminarSpecifics';
import siteOptions from './siteOptions';
import stylistTool from './stylistTool';
import user from './user';
import salonConsultaionSiteOptions from './salonConsultaionSiteOptions';
import homeCareItemList from './homeCareItemList';
import salonConsultationTop from './salonConsultationTop';
import sublimicHome from './sublimicHome';
import sublimicDiagnosis from './sublimicDiagnosis';
import beautyConsultationDiagnosis from './beautyConsultationDiagnosis';
import salonSolutionList from './salonSolutionList';
import salonSetting from './salonSetting';
import customerSearch from './customerSearch';
import userSurvey from './userSurvey';
import scalpCamera from './scalpCamera';
import updateScalpCameraOption from './scalpCameraOption';
import stylistDiagnosis from './stylistDiagnosis';
import sublimicDiagnosisResult from './sublimicDiagnosisResult';
import customerProfile from './customerProfile';
import homeCareItemConcerns from './homeCareItemConcerns';
import salonVisit from './salonVisit';
import sublimicDiagnosisLogics from './sublimicDiagnosisLogics';
import authSalonSettings from './authSalonSettings';
import diagnosisResult from './diagnosisResult';
import customerRegistration from './customerRegistration';
import putSalonSettings from './putSalonSettings';
import scalpCameraDiagnosis from './scalpCameraDiagnosis';
import salonVisitTool from './salonVisitTool';
import beautyContents from './beautyContents';
import styles from './styles';
import inspirationArticles from './inspirationArticles';

const rootReducer = combineReducers({
  auth: authReducer.reducer,
  entries,
  error,
  hairDiagnosis,
  intl: intlReducer,
  locale,
  newsAndEvents,
  pages,
  rangeSkinBodyCare: productRangeSkinBodyCare,
  rangeHairCare: productRangeHairCare,
  rangeHairColor: productRangeHairColor,
  rangeMakeUp: productRangeMakeUp,
  rangeMens: productRangeMens,
  rangePerm: productRangePerm,
  rangeStyling: productRangeStyling,
  screenSize,
  searchables,
  seminars,
  seminarSpecifics,
  siteOptions,
  stylistTool,
  user,
  salonConsultaionSiteOptions,
  homeCareItemList,
  salonConsultationTop,
  sublimicHome,
  sublimicDiagnosis,
  beautyConsultationDiagnosis,
  salonSolutionList,
  salonSetting,
  customerSearch,
  userSurvey,
  scalpCamera,
  scalpCameraDiagnosis,
  cameraOption: updateScalpCameraOption,
  stylistDiagnosis,
  sublimicDiagnosisResult,
  customerProfile,
  homeCareItemConcerns,
  salonVisit,
  sublimicDiagnosisLogics,
  authSalonSettings,
  diagnosisResult,
  customerRegistration,
  putSalonSettings,
  salonVisitTool,
  beautyContents,
  styles,
  inspirationArticles,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js